/**
 * DIY hard caps for user_ratios mode.
 *
 * ``user_max_percent`` — max a customer may set when picking proportions.
 * ``max_percent`` — max the auto engine allocates (typically lower); not used
 * as a DIY hard stop. When ``user_max_percent`` is unset, DIY is uncapped
 * up to 100% (soft-cap hints still come from max_percent).
 */

export function getDiyHardCapPercent(ingredient) {
  if (!ingredient || ingredient.user_max_percent == null) return null;
  const cap = Number(ingredient.user_max_percent);
  return Number.isFinite(cap) ? cap : null;
}

/**
 * Clamp a percentages map to each ingredient's DIY hard cap.
 * Does not rebalance to 100% — the existing ratio UI handles that.
 *
 * @returns {{ percentages: Object<string, number>, didClamp: boolean }}
 */
export function clampPercentagesToDiyCaps(percentages, ingredients) {
  if (!percentages || typeof percentages !== 'object') {
    return { percentages: {}, didClamp: false };
  }
  const byId = new Map(
    (ingredients || []).map((ing) => [ing.id, ing]),
  );
  const next = {};
  let didClamp = false;

  for (const [id, raw] of Object.entries(percentages)) {
    const value = Number(raw);
    if (!Number.isFinite(value)) continue;
    const cap = getDiyHardCapPercent(byId.get(id));
    let clamped = value;
    if (cap != null && value > cap) {
      clamped = cap;
      didClamp = true;
    }
    next[id] = Math.round(clamped * 100) / 100;
  }

  return { percentages: next, didClamp };
}
